var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-tabs',{model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_c('b-tab',{attrs:{"title":"List View"}},[(_vm.tabIndex === 0)?_c('list-view'):_vm._e()],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Matrix View"}},[(_vm.tabIndex === 1)?_c('matrix-view'):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0060032c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/payment/viplevelwithdraw/viplevelpayment/VIPLevelPaymentTable.vue
// module id = 1236
// module chunks = 1